import React, { useContext, useState } from 'react'
import FilterContext from '../../context/FilterContext'
import { LuFilter, LuX } from 'react-icons/lu'
import SessionContext from '../../context/SessionContex'
import utils from '../../utils'

function MobileSideBar(props) {
    const [showFilter, setShowFilter] = useState(false)
    const sessionCtx = useContext(SessionContext)
    const categories = sessionCtx.categories
    const filterCtx = useContext(FilterContext)

    const { houseCategory, houseRooms } = filterCtx
    const { storiesParam, bathroomsParam } = props

    const roomNames = utils.roomNames
    const stories = utils.stories
    const bathrooms = utils.bathrooms

    const FilterSection = ({ title, isOpen, children }) => (
        <div className="collapse collapse-arrow bg-transparent border-b border-outline-variant/10 rounded-none">
            <input type="checkbox" defaultChecked={isOpen} />
            <div className="collapse-title px-0 py-4 font-black text-[10px] uppercase tracking-[0.2em] text-on-surface">
                {title}
            </div>
            <div className="collapse-content px-0">
                <div className="flex flex-col gap-2 pb-2">
                    {children}
                </div>
            </div>
        </div>
    )

    const FilterItem = ({ label, active, onClick, onClear }) => (
        <div
            onClick={onClick}
            className={`
                flex items-center justify-between px-4 py-3 rounded-xl transition-all
                ${active
                    ? 'bg-primary text-white shadow-lg shadow-primary/20'
                    : 'bg-surface-container-low text-on-surface-variant'}
            `}
        >
            <span className={`text-sm ${active ? 'font-black' : 'font-medium'}`}>{label}</span>
            {active && (
                <LuX
                    size={18}
                    onClick={(e) => { e.stopPropagation(); onClear(); }}
                />
            )}
        </div>
    )

    return (
        <div className="md:hidden">
            {/* Floating Action Button */}
            {!showFilter && (
                <button
                    onClick={() => setShowFilter(true)}
                    className="fixed bottom-8 right-8 z-40 w-14 h-14 bg-primary text-white rounded-full shadow-2xl flex items-center justify-center active:scale-90 transition-transform border-4 border-white"
                >
                    <LuFilter size={24} />
                </button>
            )}

            {/* Slide-up Overlay */}
            <div className={`
                fixed inset-0 z-50 transition-all duration-500
                ${showFilter ? 'visible' : 'invisible'}
            `}>
                {/* Backdrop */}
                <div
                    className={`absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity duration-500 ${showFilter ? 'opacity-100' : 'opacity-0'}`}
                    onClick={() => setShowFilter(false)}
                />

                {/* Content Panel */}
                <div className={`
                    absolute bottom-0 left-0 right-0 bg-white rounded-t-[32px] p-8 max-h-[85vh] overflow-y-auto transition-transform duration-500 transform
                    ${showFilter ? 'translate-y-0' : 'translate-y-full'}
                `}>
                    <div className="flex justify-between items-center mb-8">
                        <div className="flex items-center gap-3">
                            <LuFilter className="text-primary" size={20} />
                            <h2 className="font-headline font-black text-xl text-on-surface tracking-tight">Filter Plans</h2>
                        </div>
                        <button
                            onClick={() => setShowFilter(false)}
                            className="p-2 bg-surface-container rounded-full text-on-surface-variant"
                        >
                            <LuX size={20} />
                        </button>
                    </div>

                    <div className="space-y-2">
                        <FilterSection title="Building Style" isOpen={!!houseCategory}>
                            <div className="grid grid-cols-1 gap-2">
                                {categories.map((cat, idx) => (
                                    <FilterItem
                                        key={idx}
                                        label={cat.name}
                                        active={houseCategory === cat.slug}
                                        onClick={() => props.changeCategoryParam(cat.slug)}
                                        onClear={() => props.changeCategoryParam()}
                                    />
                                ))}
                            </div>
                        </FilterSection>

                        <FilterSection title="Bedrooms" isOpen={!!houseRooms}>
                            <div className="grid grid-cols-2 gap-2">
                                {roomNames.map((room, idx) => (
                                    <FilterItem
                                        key={idx}
                                        label={room.name}
                                        active={houseRooms === room.value}
                                        onClick={() => props.changeRoomsParam(room.value)}
                                        onClear={() => props.changeRoomsParam(0)}
                                    />
                                ))}
                            </div>
                        </FilterSection>

                        <FilterSection title="Stories" isOpen={!!storiesParam}>
                            <div className="grid grid-cols-2 gap-2">
                                {stories.map((story, idx) => (
                                    <FilterItem
                                        key={idx}
                                        label={story.name}
                                        active={parseInt(storiesParam) === story.value}
                                        onClick={() => props.changeStoriesParam(story.value)}
                                        onClear={() => props.changeStoriesParam(0)}
                                    />
                                ))}
                            </div>
                        </FilterSection>

                        <FilterSection title="Bathrooms" isOpen={!!bathroomsParam}>
                            <div className="grid grid-cols-2 gap-2">
                                {bathrooms.map((bath, idx) => (
                                    <FilterItem
                                        key={idx}
                                        label={bath.name}
                                        active={parseInt(bathroomsParam) === bath.value}
                                        onClick={() => props.changeBathroomsParam(bath.value)}
                                        onClear={() => props.changeBathroomsParam(0)}
                                    />
                                ))}
                            </div>
                        </FilterSection>
                    </div>

                    <div className="mt-10 flex gap-4">
                        <button
                            onClick={() => {
                                props.changeCategoryParam();
                                props.changeRoomsParam(0);
                                props.changeStoriesParam(0);
                                props.changeBathroomsParam(0);
                            }}
                            className="flex-1 py-4 text-[10px] font-black uppercase tracking-widest text-on-surface-variant"
                        >
                            Clear All
                        </button>
                        <button
                            onClick={() => setShowFilter(false)}
                            className="flex-[2] py-4 bg-primary text-white rounded-2xl font-black text-[10px] uppercase tracking-widest shadow-lg shadow-primary/20"
                        >
                            Apply Filters
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MobileSideBar